import React, {createContext, useContext, useState} from 'react';

import {License} from '@br/idm-api';

import {LicenseTransferContextType} from './types';

const LicenseTransferContext = createContext<LicenseTransferContextType>({} as LicenseTransferContextType);

const LicenseTransferContextProvider = ({children}: {children: React.ReactNode}) => {
    const [targetLicense, setTargetLicense] = useState<License | undefined>(undefined);

    return (
        <LicenseTransferContext.Provider value={{targetLicense, setTargetLicense}}>
            {children}
        </LicenseTransferContext.Provider>
    );
};

const useLicenseTransferContext = () => useContext(LicenseTransferContext);

export {LicenseTransferContextProvider, useLicenseTransferContext};
